import React from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';


  const newsItems = [
    {
      id: 1,
      imgSrc: subMenuHome,
      title: 'İsitmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 2,
      imgSrc: subMenuPartners,
      title: 'Ventilyasiya',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
      id: 3,
      imgSrc: subMenuProjects,
      title: 'Soyutma, kondisionerləşdirmə',
      description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
    },
    {
        id: 4,
        imgSrc: subMenuHome,
        title: 'Santexnika',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 5,
        imgSrc: subMenuPartners,
        title: 'Yanğınsöndürmə',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 6,
        imgSrc: subMenuProjects,
        title: 'Elektrik sistemləri',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 7,
        imgSrc: subMenuHome,
        title: 'Aşağı cərəyan',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 8,
        imgSrc: subMenuPartners,
        title: 'Avtomatlaşdırma sistemləri',
         description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
      {
        id: 9,
        imgSrc: subMenuProjects,
        title: 'Kanal sexi',
        description: 'Biz, yaşayış və iş məkanları üçün mərkəzi kondisioner, havalandırma, istilik və su filtrasiya sistemlərinin layihələndirilməsi və quraşdırılması üzrə ixtisaslaşmışıq.',
      },
  ];

const CareersProfessionalItems = () => {


      const { t } = useTranslation();

  return (
    <div className='pt-[88px] md:pt-[104px] bg-[#FBFBFB]'>
        <div className='max-w-containerSm md:max-w-container mx-auto gap-5'>
        <div className='text-[#1C1C1C]'>
    <p className='mt-6'>Təcrübəli mütəxəssislər üçün geniş karyera inkişafı imkanlarını təklif edirik. Onlar ən mürəkkəb və irimiqyaslı layihələrlə işləməklə təcrübələrini daha da zənginləşdir, peşəkarlıq səviyyələrini daim artıtmağa nail olurlar.    </p>
    <p className='mt-6'>Biz əməkdaşlarımıza ideyalarını reallaşdırmaq və innovativ həlləri tətbiq etmək üçün şərait yaradırıq. Peşakar mütəxəssislərimizin bilik və bacarıqlarını yüksək qiymətləndiririk və təcrübə mübadiləsini təşfiq edirik.    </p>
    <p className='mt-6'>Şirkətimizin hər bir üzvünün peşəkar və şəxsi inkişafı Akondun uğur hekayəsinin səbəblərindən biridir.</p>
    
        </div>


    </div>
    </div>
  )
}

export default CareersProfessionalItems